import React, { createContext, Component } from 'react';
import { withRouter } from 'next/router';
import Cookie from 'js-cookie';
import { api } from 'helpers';

const UserContext = createContext(null);

class UserProvider extends Component {
	state = {
		...this.props.userProps,
		isLoggedIn: null,
	};

	methods = {
		register: this.register.bind(this),
		login: this.login.bind(this),
		forgotPassword: this.forgotPassword.bind(this),
		resetPassword: this.resetPassword.bind(this),
	};

	register(data) {
		return this.asyncFunctionDecorator(() =>
			api.post('register', data).then(({ accessToken, user }) => {
				Cookie.set('accessToken', accessToken);
				this.setState({
					isLoggedIn: true,
				});
			})
		);
	}

	login(data) {
		return this.asyncFunctionDecorator(() =>
			api.post('login', data).then(({ accessToken, user }) => {
				Cookie.set('accessToken', accessToken);
				this.setState({
					isLoggedIn: true,
					user,
				});
			})
		);
	}

	forgotPassword(data) {
		return this.asyncFunctionDecorator(() => api.post('forgot-password', data));
	}

	resetPassword(data) {
		return this.asyncFunctionDecorator(() => api.post('reset-password', data));
	}

	asyncFunctionDecorator = async (asyncFunc) => {
		return await asyncFunc().catch((err) => {
			return Promise.reject(err.response);
		});
	};

	render() {
		return <UserContext.Provider value={{ ...this.state, ...this.methods }}>{this.props.children}</UserContext.Provider>;
	}
}

export default withRouter(UserProvider);
export const UserConsumer = UserContext.Consumer;
